import AboutApp from "../../components/Qna";
import PrivacyPolicy from "../../components/PrivacyPolicy";
import Tnc from "../../components/Tnc";
import AboutUs from "../../components/AboutUs";

const AppInfo = () => {
    return (
        <div className="flex flex-col gap-3">
            <PrivacyPolicy />
            <Tnc />
            <AboutUs />
            <AboutApp />
        </div>
    )
}

export default AppInfo;